(() => {
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'INR';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency, maximumFractionDigits: 0 }).format(cents / 100);
  };

  const openDialog = (dialog) => {
    if (!dialog) return;
    dialog.showModal();
    document.body.classList.add('locked');
  };
  const closeDialog = (dialog) => {
    if (!dialog) return;
    dialog.close();
    document.body.classList.remove('locked');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    const closer = event.target.closest('[data-dialog-close]');
    if (opener) openDialog(document.querySelector(opener.dataset.dialogOpen));
    if (closer) closeDialog(closer.closest('dialog'));
  });

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog && !dialog.classList.contains('drawer')) closeDialog(dialog);
    });
    dialog.addEventListener('close', () => document.body.classList.remove('locked'));
  });

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-sticky', window.scrollY > 160);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal]').forEach((element) => revealObserver.observe(element));

  const cartDialog = document.querySelector('#CartDrawer');
  const cartLines = cartDialog?.querySelector('[data-cart-lines]');
  const cartEmpty = cartDialog?.querySelector('[data-cart-empty]');
  const cartFooter = cartDialog?.querySelector('[data-cart-footer]');

  const renderCart = async (open = false) => {
    if (!cartDialog) return;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
    cartEmpty.hidden = cart.item_count !== 0;
    cartFooter.hidden = cart.item_count === 0;
    cartDialog.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    cartLines.innerHTML = cart.items.map((item, index) => `
      <article class="drawer-line">
        ${item.image ? `<a href="${item.url}"><img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" width="184" height="230"></a>` : ''}
        <div>
          <a class="drawer-line__title" href="${item.url}">${item.product_title}</a>
          <p class="drawer-line__meta">${item.variant_title || ''}${item.quantity > 1 ? ` · Qty ${item.quantity}` : ''}</p>
          <span>${money(item.final_line_price)}</span>
        </div>
        <button class="drawer-line__remove" type="button" data-cart-remove="${index + 1}">Remove</button>
      </article>`).join('');
    if (open) openDialog(cartDialog);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const previous = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(window.GroundUp.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this item');
      await renderCart(true);
      button.textContent = 'Added';
    } catch (error) {
      button.textContent = error.message;
    } finally {
      setTimeout(() => { button.disabled = false; button.textContent = previous; }, 1400);
    }
  });

  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    remove.disabled = true;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(remove.dataset.cartRemove), quantity: 0 }) });
    await renderCart(false);
  });

  let searchTimer;
  document.querySelectorAll('[data-predictive-input]').forEach((input) => {
    input.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const target = document.querySelector(input.dataset.resultsTarget);
      if (input.value.trim().length < 2) { target.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        target.setAttribute('aria-busy', 'true');
        const url = `${window.GroundUp.searchUrl}?q=${encodeURIComponent(input.value)}&section_id=predictive-search`;
        const html = await fetch(url).then((response) => response.text());
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        target.innerHTML = parsed.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        target.setAttribute('aria-busy', 'false');
      }, 240);
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const section = select.closest('[data-product-section]');
    const variants = JSON.parse(section.querySelector('[data-variant-json]').textContent);
    const button = section.querySelector('[data-product-submit]');
    const price = section.querySelector('[data-product-price]');
    const availability = section.querySelector('[data-product-availability]');
    const sticky = document.querySelector('[data-sticky-atc]');
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      price.textContent = money(variant.price);
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldText;
      if (availability) {
        availability.classList.toggle('is-sold-out', !variant.available);
        availability.innerHTML = `<span aria-hidden="true"></span>${variant.available ? 'Available' : 'Currently unavailable'}`;
      }
      if (sticky) {
        const stickyButton = sticky.querySelector('button');
        const stickyPrice = sticky.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        if (stickyButton) {
          stickyButton.disabled = !variant.available;
          stickyButton.textContent = variant.available ? button.dataset.availableText : button.dataset.soldText;
        }
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
    });
  });

  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const primaryAtc = document.querySelector('[data-product-submit]');
  if (stickyAtc && primaryAtc) {
    const stickyObserver = new IntersectionObserver(([entry]) => stickyAtc.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    stickyObserver.observe(primaryAtc);
    stickyAtc.querySelector('button')?.addEventListener('click', () => primaryAtc.click());
  }

  document.querySelectorAll('[data-auto-submit]').forEach((field) => field.addEventListener('change', () => field.form.submit()));

  /* Field Edition: restrained motion that adds depth without hiding content. */
  const fieldEdition = document.querySelector('[data-field-edition]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (fieldEdition) {
    document.querySelectorAll('[data-proof-list] details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        detail.parentElement.querySelectorAll('details[open]').forEach((other) => {
          if (other !== detail) other.open = false;
        });
      });
    });

    if (!reducedMotion) {
      const parallaxLayers = [...document.querySelectorAll('[data-parallax-layer]')];
      let scheduled = false;
      const updateFieldMotion = () => {
        const viewport = window.innerHeight;
        parallaxLayers.forEach((layer) => {
          const rect = layer.parentElement.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewport) return;
          const progress = (viewport - rect.top) / (viewport + rect.height);
          layer.style.transform = `translate3d(0, ${(progress - .5) * 34}px, 0)`;
        });
        scheduled = false;
      };
      window.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(updateFieldMotion);
      }, { passive: true });
      updateFieldMotion();
    }
  }
})();
